import axios from "axios";

const EXT_PREVIEW_MAP = {
  mp4: "video",
  webm: "video",
  ogg: "video",
  mov: "video",
  avi: "video",
  mp3: "audio",
  wav: "audio",
  aac: "audio",
  m4a: "audio",
  pdf: "pdf",
  doc: "word",
  docx: "word",
  xls: "excel",
  xlsx: "excel"
};

const LABEL_PREVIEW_MAP = [
  { keywords: ["视频"], type: "video" },
  { keywords: ["音频"], type: "audio" },
  { keywords: ["pdf"], type: "pdf" },
  { keywords: ["word", "文档", "doc"], type: "word" },
  { keywords: ["excel", "表格", "xls"], type: "excel" }
];

/** 从 URL 后缀解析预览类型 */
export function getPreviewTypeByUrl(url = "") {
  const path = (url || "").split("?")[0];
  const ext = path.split(".").pop().toLowerCase();
  return EXT_PREVIEW_MAP[ext] || "";
}

/** 从字典 resource_type 解析预览类型 */
export function getPreviewTypeByDict(resourceType, resourceTypeList = []) {
  const item = resourceTypeList.find(
    d => String(d.dictValue) === String(resourceType)
  );
  if (!item) {
    return "";
  }
  const text = `${item.dictLabel || ""}${item.dictValue || ""}`.toLowerCase();
  const matched = LABEL_PREVIEW_MAP.find(entry =>
    entry.keywords.some(keyword => text.includes(keyword.toLowerCase()))
  );
  return matched ? matched.type : "";
}

/**
 * 解析资源预览类型
 * @param {object} options
 * @param {string} options.url
 * @param {string|number} [options.resourceType]
 * @param {Array} [options.resourceTypeList]
 */
export function resolvePreviewType(options = {}) {
  const { url, resourceType, resourceTypeList = [] } = options;
  return (
    getPreviewTypeByDict(resourceType, resourceTypeList) ||
    getPreviewTypeByUrl(url) ||
    "unknown"
  );
}

const previewAxios = axios.create({
  timeout: 120000,
  responseType: "arraybuffer"
});

/** 是否为旧版 Office 格式（前端库不支持） */
export function isLegacyOfficeFormat(url = "") {
  const ext = (url || "").split("?")[0].split(".").pop().toLowerCase();
  return ext === "doc" || ext === "xls";
}

/** 拉取文件为 ArrayBuffer，供 @vue-office 预览 */
export function fetchPreviewFile(url) {
  return previewAxios.get(url).then(res => res.data);
}

/** 根据预览类型获取 OSS 上传目录 */
export function getUploadFolderByPreviewType(previewType) {
  const folderMap = {
    video: "video",
    audio: "audio",
    pdf: "file",
    word: "file",
    excel: "file"
  };
  return folderMap[previewType] || "file";
}

/** 根据预览类型获取 accept */
export function getAcceptByPreviewType(previewType) {
  const acceptMap = {
    video: "video/*",
    audio: "audio/*",
    pdf: ".pdf,application/pdf",
    word: ".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    excel:
      ".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  };
  return acceptMap[previewType] || "*";
}



// WEBPACK FOOTER //
// ./src/utils/resourcePreview.js